export default "__VITE_ASSET__CD9dvj$e__"